export const INSTRUMENTS = {
  Forex: [
    { s: "EUR/USD", p: 1.0842, d: 0.12, spr: 0.2 },
    { s: "GBP/USD", p: 1.2691, d: -0.08, spr: 0.5 },
    { s: "USD/JPY", p: 156.34, d: 0.21, spr: 0.4 },
    { s: "AUD/USD", p: 0.6612, d: -0.15, spr: 0.6 },
    { s: "USD/CHF", p: 0.9021, d: 0.05, spr: 0.5 },
    { s: "USD/CAD", p: 1.3712, d: 0.09, spr: 0.7 },
  ],
  Metals: [
    { s: "XAU/USD", p: 2338.5, d: 0.44, spr: 12 },
    { s: "XAG/USD", p: 29.72, d: -0.31, spr: 2.4 },
    { s: "XPT/USD", p: 1012.3, d: 0.18, spr: 8 },
  ],
  Commodities: [
    { s: "WTI Oil", p: 78.42, d: -0.62, spr: 0.05 },
    { s: "Brent", p: 82.91, d: -0.48, spr: 0.05 },
    { s: "NatGas", p: 2.31, d: 1.12, spr: 0.02 },
  ],
  Indices: [
    { s: "US500", p: 5288.4, d: 0.35, spr: 0.5 },
    { s: "US30", p: 39112, d: 0.22, spr: 2 },
    { s: "NAS100", p: 18642, d: 0.51, spr: 1 },
    { s: "GER40", p: 18384, d: -0.11, spr: 1.2 },
  ],
  Stocks: [
    { s: "AAPL", p: 214.29, d: 0.63, spr: 0.03 },
    { s: "TSLA", p: 183.01, d: -1.24, spr: 0.05 },
    { s: "AMZN", p: 186.57, d: 0.41, spr: 0.04 },
    { s: "MSFT", p: 449.78, d: 0.28, spr: 0.05 },
  ],
  Crypto: [
    { s: "BTC/USD", p: 67240, d: 1.82, spr: 18 },
    { s: "ETH/USD", p: 3512, d: 0.94, spr: 3.5 },
    { s: "SOL/USD", p: 168.2, d: 2.31, spr: 0.4 },
  ],
};

// Session-based average spreads (pip) — indicative demo values, styled after institutional broker tables
export const SPREADS = [
  { s: "EUR/USD", eu: 0.26, us: 0.26, asia: 0.36 },
  { s: "USD/JPY", eu: 0.46, us: 0.45, asia: 0.62 },
  { s: "GBP/USD", eu: 0.58, us: 0.63, asia: 0.79 },
  { s: "EUR/JPY", eu: 0.88, us: 0.83, asia: 1.08 },
  { s: "USD/CAD", eu: 0.97, us: 0.96, asia: 1.20 },
  { s: "AUD/USD", eu: 0.81, us: 0.87, asia: 0.91 },
  { s: "XAU/USD", eu: 12.70, us: 11.35, asia: 14.68 },
  { s: "US500.IDX", eu: 0.50, us: 0.50, asia: 0.50 },
  { s: "GER40.IDX", eu: 1.05, us: 1.20, asia: 1.77 },
  { s: "BRENT.CMD", eu: 0.05, us: 0.05, asia: 0.05 },
];

export function tick(price) {
  const move = (Math.random() - 0.5) * price * 0.0008;
  return +(price + move).toFixed(price > 1000 ? 1 : price > 10 ? 2 : 4);
}

// derive bid/ask/volume for the quotes table
export function quote(r) {
  const digits = r.p > 1000 ? 1 : r.p > 10 ? 2 : r.p >= 1 ? 4 : 5;
  const pip = r.p > 100 ? 0.01 : 0.0001;
  const half = (r.spr * pip) / 2;
  return {
    bid: (r.p - half).toFixed(digits),
    ask: (r.p + half).toFixed(digits),
    vol: (Math.random() * 4 + 0.5).toFixed(2),
  };
}
